import React from 'react'
import * as R from 'ramda'

const schoolList = ({ schools }) => (
  <div
    className="schoolList"
    style={{ maxWidth: '100%' }}
    data-testid="school-list"
  >
    Sent from {schools.map(R.prop('name')).join(', ')}
  </div>
)

export default schoolList



// WEBPACK FOOTER //
// ./src/screens/Flyers/screens/FlyerDetail/components/FlyerDetailBody/components/SchoolList.js